module.exports = __webpack_public_path__ + "media/images/driver-avatar-large-34fe18d80511f0206186e6971dfc94de.svg";